import { ReactElement } from 'react'
import { images } from 'configureBrand'
import styled from 'styled-components'

const RelativeBannerWrapper = styled.div`
  position: relative;
`

const Background = styled.div`
  width: 100%;
`

const Img = styled.img`
  width: 100%;
  height: 100%;
`

const Space = styled.div`
  height: 48px;
`

const DefaultLoginHeaderCards = ({
  assetHost
}: {
  assetHost: string
}): ReactElement => {
  const { loginHeaderCardsImage } = images

  const getFullImgPath = (img: string) => `${assetHost}${img}`

  return (
    <>
      <RelativeBannerWrapper>
        <Background>
          <Img src={getFullImgPath(loginHeaderCardsImage)} alt="" aria-hidden />
        </Background>
      </RelativeBannerWrapper>
      <Space />
    </>
  )
}

export default DefaultLoginHeaderCards
